import { ReactNode } from "react";
import classes from "./ConnectWalletButtonStyles.module.scss";
import classNames from "classnames";

type Props = {
  children: ReactNode;
  onClick: () => void;
  className?: string;
};

export const ConnectWalletButton = ({ children, onClick, className }: Props) => {
  return (
    <button className={classNames(classes.component, className)} onClick={onClick}>
      <span className={classes.label}>{children}</span>
    </button>
  );
};
